export enum EAplicacaoAcrescimoDesconto {
    Valor = 1,
    Percentual = 2,
}
